<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <h4 class="text-capitalize fw-500 breadcrumb-title">
                            <i class="fas fa-money-check"></i> Riwayat Konfirmasi Transfer Manual
                        </h4>
                        <div class="action-btn">
                            <button @click="load" class="btn btn-light">
                                <i class="fas fa-sync"></i> Reload
                            </button>
                            <router-link to="/billing" class="btn btn-secondary ml-2">
                                <i class="fas fa-arrow-left"></i> Kembali ke Billing
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card p-3">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Tanggal</th>
                                <th>Mode</th>
                                <th>Amount</th>
                                <th>Bukti</th>
                                <th>Status</th>
                                <th>Catatan Admin</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loading">
                                <td colspan="7" class="text-center text-muted">Loading...</td>
                            </tr>
                            <tr v-else-if="payments.length === 0">
                                <td colspan="7" class="text-center text-muted">
                                    Belum ada konfirmasi transfer manual.
                                </td>
                            </tr>
                            <tr v-for="p in payments" :key="p.id">
                                <td>#PAY-{{ p.id }}</td>
                                <td><small>{{ formatTime(p.created_at) }}</small></td>
                                <td>
                                    <span class="badge bg-info">{{ modeLabel(p.payment_mode) }}</span>
                                    <div v-if="p.target_label" class="text-muted small">{{ p.target_label }}</div>
                                </td>
                                <td><strong>{{ formatRupiah(p.amount) }}</strong></td>
                                <td>
                                    <a v-if="p.proof_image_url" :href="p.proof_image_url" target="_blank">
                                        <i class="fas fa-image"></i> Lihat
                                    </a>
                                </td>
                                <td>
                                    <span :class="statusBadge(p.status)">{{ p.status.toUpperCase() }}</span>
                                </td>
                                <td>
                                    <em v-if="p.admin_note">{{ p.admin_note }}</em>
                                    <span v-else class="text-muted">—</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                    <small class="text-muted">Total: {{ total }} | Page {{ page }} / {{ totalPages }}</small>
                    <div>
                        <button class="btn btn-sm btn-light mr-2" :disabled="page <= 1" @click="goPage(page - 1)">Prev</button>
                        <button class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="goPage(page + 1)">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    data() {
        return {
            loading: false,
            payments: [],
            total: 0,
            page: 1,
            limit: 20,
        };
    },
    computed: {
        totalPages() {
            return Math.max(1, Math.ceil(this.total / this.limit));
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        formatRupiah(n) {
            return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
        },
        formatTime(ms) {
            if (!ms) return '—';
            return moment(parseInt(ms)).format('DD MMM YYYY HH:mm');
        },
        modeLabel(m) {
            switch (m) {
                case 'buy_package': return 'Beli Paket';
                case 'topup': return 'Top Up Saldo';
                case 'topup_chatgpt': return 'Top Up ChatGPT';
                case 'addon': return 'Add-on';
                case 'shop_order': return 'Shop Order';
                default: return m;
            }
        },
        statusBadge(s) {
            if (s === 'approved') return 'badge bg-success';
            if (s === 'rejected') return 'badge bg-danger';
            return 'badge bg-warning text-dark';
        },
        goPage(p) {
            if (p < 1 || p > this.totalPages) return;
            this.page = p;
            this.load();
        },
        async load() {
            this.loading = true;
            try {
                const r = await axios.get('payment/manual/list', {
                    params: { page: this.page, limit: this.limit },
                });
                if (r.data && r.data.success) {
                    this.payments = r.data.data.payments || [];
                    this.total = r.data.data.total || 0;
                }
            } catch (e) {
                this.$toast && this.$toast.error('Gagal load: ' + (e.message || ''));
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
